.SecureContainer
    margin: 0 auto
    padding: 0
    display: flex
    align-items: center
    justify-content: center
    color: rgb($globalSettingsFontTertiary)
    stroke: rgb($globalSettingsFontTertiary)
    font-size: 12px
    white-space: nowrap
    clear: both
    box-sizing: border-box
    svg
        padding: 0
        margin: 0 5px

.SecureText
    display: block
    cursor: pointer
    div
        display: flex
        align-items: center
        justify-content: center

.SecureDetailsContainer
    position: absolute
    bottom: 0
    top: 0
    left: 0
    right: 0
    font-size: 12px
    box-sizing: border-box
    z-index: $indexItem
    .SecureDetailsContainerInner
        height: 100%
        max-height: 100%
        display: flex
        flex-direction: column
        align-items: flex-start
        margin: 0
        padding: 20px
        box-sizing: border-box
        color: rgb($globalSettingsFontPrimary)
        background-color: rgb($globalSettingsBackgroundPrimary)
        white-space: normal
        border-radius: $globalSettingsRounding
        .SecureDisclaimer
            width: 100%
            display: flex
            flex: 1
            overflow-y: auto
        .SecureHeaderContainer
            width: 100%
            display: flex
            flex-direction: row
            justify-content: space-between
        .SecureTitle
            font-size: 14px
            font-weight: 700
        .TermsContainer
            width: 100%
            display: flex
            flex-direction: row
            flex-wrap: wrap
            gap: 0 10px
        .SecureHeaderTitle
            font-size: 24px
            line-height: 1.4
            display: inline-block
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
        .SecureButton
            margin-top: auto
